const reducer = (state, action) => {
  switch (action.type) {
    case "SET_USER_INFO":
      return {
        user: {
          ...state.user,
          name: action.payload.name,
          lastName: action.payload.lastName,
          avatar: action.payload.avatar,
          token: action.payload.token,
          profileName: action.payload.profileName,
          evaluationName: action.payload.evaluationName,
          microphone_unactive: action.payload.microphone_unactive
        },
      };
    case "SET_TEST_INFO":
      return {
        test: action.payload,
      };
    case "LOGOUT":
      return {
        user: {},
      };
    default:
      return state;
  }
};

export default reducer;
